import React from 'react';
import vue from '../../../assets/vue.png';

const Vue = () => (
  <section id="vue">
    <img data-src={vue} alt="Vue" />
    <h2>Vue</h2>
    <p>
      Développé depuis 2014 par <strong>Evan You</strong><br />
      Facilement intégrable aux projes existants<br />
      Liaison de données bi-directionnelle<br />
      Idéal pour les applications à grande échelle<br />
      Outil <strong>CLI</strong> très performant<br />
      Framework rapide, léger et fiable pour un code stable
    </p>
  </section>
);

export default Vue;
